import React from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'

const VideoPlayerModal = (props) => {
  return (
    <>
		<div className="text-center">
			<Modal
				{...props}
				size="xl"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Body>
					<div className='py-2'>
						<video className='container' controls autoPlay playsInline onContextMenu={(e) => e.preventDefault()}>
							<source src={props.videosrc} type="video/mp4"/>
						</video>
					</div>
				</Modal.Body>
					<Row className='video-player-button'>
						<Col xs={{span:4, offset:4}}  md={{span:2, offset:5}} className="text-center">
							<Button onClick={props.onHide} className="product-modal-close-button"><img className='popup-modal-close-icon' src={"/assets/icons/close-icon.png"}  alt="close" /></Button>
						</Col>
					</Row>
			</Modal>
		</div>
    </>
  )
}

export default VideoPlayerModal
